<template>
  <div class="flex flex-col sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-[520px]">
      <div class="items-center bg-white px-12 pb-6 shadow sm:rounded-lg">
        <div class="flex flex-col items-center text-center justify-center pt-14">
          <SectionHeader
              class="mx-auto !justify-center pb-2"
              :title="invitationCopy.copy1"
          >
          </SectionHeader>
          <p class="text-gray-600 text-md text-center mb-8">
            {{ invitationCopy.copy2 }}
          </p>

        </div>
        <div v-if="validInvitation">
          <form @submit.prevent="handleSubmit">
                  <div class="flex flex-col">
                    <InputText
                        id="ownerName"
                        v-model:value="values.first_name"
                        v-model:errors="errors.first_name"
                        :label="__('Your First Name')"
                        :placeholder="__('Enter your first name')"
                        class="pb-8"
                        required
                    />
                    <InputText
                        id="ownerLastName"
                        v-model:value="values.last_name"
                        v-model:errors="errors.last_name"
                        :label="__('Your Last Name')"
                        :placeholder="__('Enter your last name')"
                        class="pb-8"
                        required
                    />
                    <InputEmail
                        id="email"
                        :value="props.invitation?.email"
                        :label="__('Email')"
                        :placeholder="__('Your email')"
                        class="pb-8"
                        disabled
                    />
                    <InputPassword
                        id="password"
                        v-model:value="values.password"
                        v-model:errors="errors.password"
                        :label="__('Password')"
                        :placeholder="__('Choose your password')"
                        class="pb-5"
                        required
                    />

                    <div v-if="startTyping">
                      <div class="flex flex-row gap-2 pb-3">
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.min
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.min
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('min 8 characters') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.upper
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.upper
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one uppercase letter') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.lower
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.lower
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one lowercase letter') }}
                        </span>
                        </div>
                      </div>
                      <div class="flex flex-row gap-2 pb-4">
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.number
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.number
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one number') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.special
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.special
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one special character (@, #, $)') }}
                        </span>
                        </div>
                      </div>
                    </div>

                    <InputPassword
                        id="password_confirmation"
                        v-model:value="values.password_confirmation"
                        v-model:errors="errors.password_confirmation"
                        :label="__('Confirm your password')"
                        :placeholder="__('Rewrite your password')"
                        required
                        class="pb-8 md:col-start-2"
                    />

                    <div class="space-y-2 pb-8">
                      <InputCheckbox
                          id="recruit"
                          v-model:value="values.recruit"
                          v-model:errors="errors.recruit"
                          :label="__('I agree to the')"
                          class="mb-6"
                      >
                        <template #default>
                          <a href="/termeni-si-conditii" class="text-black underline">{{
                              __('terms and conditions')
                            }}</a>
                          {{ __(' and the ') }}
                          <a href="/termeni-si-conditii" class="text-black underline">{{
                              __('privacy policy')
                            }}</a
                          >.
                        </template>
                      </InputCheckbox>
                    </div>

                    <div class="text-center">
                      <p class="text-sm">
                        {{__('Already have an account?')}}
                        <a @click="redirectToLogin" class="cursor-pointer font-medium text-primary">Sign In</a>
                      </p>
                    </div>
                  </div>

                  <div
                      class="mt-4 flex flex-col gap-2 md:flex-row-reverse md:justify-center items-center"
                  >
                    <Button
                        class="flex items-center justify-center gap-1.5"
                        :type="isLoading ? 'button' : 'submit'"
                        :disabled="isLoading"
                        style="width: 10rem !important"
                    >
                      <Icon
                          v-if="isLoading"
                          class="animate-spin text-lg"
                          name="progress_activity"
                      />
                      <span>{{ __('Sign Up') }}</span>
                    </Button>
                  </div>
                </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from 'vue';
import { useToast } from 'vue-toastification';
import { __ } from '@/helpers';
import { Button } from '../../../../components/block/button';
import { Icon } from '../../../../components/block/icon';
import { InputPassword } from '../../../../components/form/input-password';
import { InputEmail } from '../../../../components/form/input-email';
import { SectionHeader } from '../../../components/section-header';
import { InputCheckbox } from '../../../../components/form/input-checkbox';
import axios from 'axios';
import { InputText } from "../../../../components/form/input-text";

const toast = useToast();
const successMessage = ref(null);
const startTyping = ref(false);

const props = defineProps({
  invitation: {
    type: Object,
    default: false
  }
});

const validInvitation = computed(() => {
  return props.invitation !== null;
})
const invitationCopy = computed(() => {
  return {
    'copy1': validInvitation.value
        ? `${props.invitation?.company?.name || __('A company')} ${__('invited you to join the team')}`
        : __('Invitation expired'),
    'copy2': validInvitation.value
        ? __('Set up your details to access your account.')
        : __('The invitation you are trying to access is no longer valid.'),
  }
})
const redirectToLogin = () => {
  window.location.href = route('front.auth.company.login');
}

const values = ref({
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  password_confirmation: '',
  recruit: false
});

const errors = ref({
  first_name: [],
  last_name: [],
  email: [],
  password: [],
  password_confirmation: [],
  recruit: []
});

const isLoading = ref(false);

const passwordRules = ref({
  min: null,
  upper: null,
  lower: null,
  number: null,
  special: null
});

watch(
    [() => values.value.password, () => values.value.password_confirmation],
    ([newPassword, confirmPassword]) => {
      if (newPassword.length > 0) {
        startTyping.value = true;
      }

      if (newPassword.length === 0) {
        startTyping.value = false;
      }

      passwordRules.value.min = newPassword.length === 0 ? null : newPassword.length >= 8;
      passwordRules.value.upper = newPassword.length === 0 ? null : /[A-Z]/.test(newPassword);
      passwordRules.value.lower = newPassword.length === 0 ? null : /[a-z]/.test(newPassword);
      passwordRules.value.number = newPassword.length === 0 ? null : /\d/.test(newPassword);
      passwordRules.value.special = newPassword.length === 0 ? null : /[^a-zA-Z0-9]/.test(newPassword);

      if (confirmPassword && newPassword !== confirmPassword) {
        errors.value.password_confirmation = [
          __('Your new password must match the confirmation password')
        ];
      } else {
        errors.value.password_confirmation = [];
      }
    }
);

async function handleSubmit() {
  const requiredFieldKeys = [
    'first_name',
    'last_name',
    'password',
    'password_confirmation',
    'recruit'
  ];
  let firstElement;

  requiredFieldKeys.forEach((key) => {
    if (!values.value[key]) {
      errors.value[key] = [__('This field is required')];

      const element = document.getElementById(key);

      if (element && !firstElement) {
        firstElement = element;
      }
    }
  });

  if (!values.value.recruit) {
    errors.value.recruit = [__('You must agree to the terms and conditions.')];
  }

  if (values.value.password !== values.value.password_confirmation) {
    errors.value.password_confirmation = [
      __('Your new password must match the confirmation password')
    ];
  }

  if (Object.values(errors.value).some((error) => error.length)) {
    if (firstElement) {
      firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  isLoading.value = true;
  successMessage.value = null;
  try {
    values.value = {
      ...values.value,
      email: props.invitation?.email,
      hash: props.invitation?.hash
    };
    console.log(values.value);
    const response = await axios.post(route('company.recruiter.register'), values.value);

    if (response?.data?.status === 'success' && response?.data?.redirect) {
      window.location.href = response.data.redirect;
    } else {
      toast.error(__('An unexpected error has occurred. Please try again.'));
    }
  } catch (error) {
    if (error?.response?.data?.errors) {
      errors.value = error.response.data.errors;
    } else if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(
          __('An unexpected error has occurred. Please try again later.')
      );
    }
  }

  isLoading.value = false;
}
</script>
